import React, {useContext, useState} from "react";
import {useTranslation} from "gatsby-plugin-react-i18next";
import styled from "styled-components";
import Cookies from 'js-cookie';
import HeaderModal from "./HeaderModal";
import {UserContext} from "../_contexts/UserContext";
import {getUserFirstName} from "../../_hooks/utils";

const UserName = styled.span`
  overflow: hidden;
  max-width: 100px;
  text-overflow: ellipsis;
`;
const ButtonWrap = styled.button`
  height: 40px;
  //--bs-btn-bg: var(--bs-primary);
  //--bs-btn-hover-bg: var(--bs-lime-green);
  //--bs-btn-active-bg: var(--bs-lime-green);
  //--bs-btn-color: var(--bs-white);
  //--bs-btn-hover-color: var(--bs-primary);
  color: var(--bs-white);
  background: var(--bs-primary);
  border: none;
  outline: none;
  @media (min-width: 640px) {
    height: 50px;
  }
  &.rotate-right {
    transform: rotate(1deg);
  }
  &.rotate-left {
    transform: rotate(-1deg);
  }
  &:hover {
    color: var(--bs-primary);
    background: var(--bs-lime-green);
    //--bs-btn-bg: var(--bs-forest-green);
    //--bs-btn-color: var(--bs-primary);
  }
`;

const UserMenu = ({location}) => {
  const [formType, setFormType] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const {t} = useTranslation();
  const {user, setUser, showUserMenu} = useContext(UserContext);
  const firstName = getUserFirstName(user?.name);
  const toggleModal = () => setModalShow((prev) => {
    return !prev
  });
  const handleLogout =  () => {
    setUser(null);
    Cookies.remove('token');
    Cookies.remove('user');
    sessionStorage.removeItem('token-is-valid');
  }
  const handleLogin = () => {
    setFormType('login');
    setModalShow(true);
  }
  const handleSignUp = () => {
    setFormType('register');
    setModalShow(true);
  }

  const handleUpdateUser = () => {
    setFormType('update');
    setModalShow(true);
  }

  return showUserMenu && (
    <div className="d-flex gap-16 gap-lg-32 me-16 me-md-40 me-lg-80">
      <HeaderModal initialFormType={formType} modalShow={modalShow} toggleModal={toggleModal}/>
      {user ? (
        <>
          <ButtonWrap type="button"
                      className="d-flex align-items-center justify-content-center gap-8 cursor-pointer font-family-heading fs-18 position-relative z-1 pe-auto px-10 py-14 rotate-left"
                      onClick={handleUpdateUser}
                      title={t('User Settings')}
          >
            <img className="rounded-circle" src={`/images/giveaway/avatars/${user.avatar_id ? user.avatar_id : '1'}.svg`} width="30" height="30" alt={`Avatar ${user.firstName}`}/>
            <UserName className="d-none d-md-block">{firstName}</UserName>
            <svg className="flex-shrink-0" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M17.4372 10.99L17.4272 11.01C17.4672 10.68 17.5072 10.34 17.5072 10C17.5072 9.66 17.4772 9.34 17.4372 9.01L17.4472 9.03L19.8872 7.11L17.4572 2.89L14.5872 4.05L14.5972 4.06C14.0772 3.66 13.5072 3.32 12.8872 3.06H12.8972L12.4372 0H7.56719L7.12719 3.07H7.13719C6.51719 3.33 5.94719 3.67 5.42719 4.07L5.43719 4.06L2.55719 2.89L0.117188 7.11L2.55719 9.03L2.56719 9.01C2.52719 9.34 2.49719 9.66 2.49719 10C2.49719 10.34 2.52719 10.68 2.57719 11.01L2.56719 10.99L0.467188 12.64L0.137188 12.9L2.56719 17.1L5.44719 15.95L5.42719 15.91C5.95719 16.32 6.52719 16.66 7.15719 16.92H7.12719L7.57719 20H12.4272C12.4272 20 12.4572 19.82 12.4872 19.58L12.8672 16.93H12.8572C13.4772 16.67 14.0572 16.33 14.5872 15.92L14.5672 15.96L17.4472 17.11L19.8772 12.91C19.8772 12.91 19.7372 12.79 19.5472 12.65L17.4372 10.99ZM9.99719 13.5C8.06719 13.5 6.49719 11.93 6.49719 10C6.49719 8.07 8.06719 6.5 9.99719 6.5C11.9272 6.5 13.4972 8.07 13.4972 10C13.4972 11.93 11.9272 13.5 9.99719 13.5Z"
                fill="currentColor"/>
            </svg>
          </ButtonWrap>
          <ButtonWrap type="button"
                      className="d-flex align-items-center justify-content-center gap-8 cursor-pointer font-family-heading fs-18 position-relative z-1 pe-auto px-10 py-14 rotate-right"
                      onClick={handleLogout}
                      title={t('Log out')}
          >
            {t('Log out')}
          </ButtonWrap>
        </>
      ) : (
        <>
          <ButtonWrap type="button"
                      className="d-flex align-items-center justify-content-center gap-8 cursor-pointer font-family-heading fs-18 position-relative z-1 pe-auto px-10 py-14 rotate-left"
                      onClick={handleLogin}
                      title={t('Log in')}
          >
            {t('Log in')}
          </ButtonWrap>
          <ButtonWrap type="button"
                      className="d-flex align-items-center justify-content-center gap-8 cursor-pointer font-family-heading fs-18 position-relative z-1 pe-auto px-10 py-14 rotate-right"
                      onClick={handleSignUp}
                      title={t('Sign up')}
          >
            {t('Sign up')}
          </ButtonWrap>
        </>
      )}
    </div>
  );
};

export default UserMenu;
